import { ApiSettings, IEnvironment } from './environment.interface';

const apiSettings: ApiSettings = {
    requisicao_retornar: 0,
    requisicao_concluir: 1,
    tp_colaborador: 1,
    tp_fornecedor: 3,
    tp_projeto: 2,
    tp_digitalizado: 1,
    tp_nato_digital: 2,
    tp_requisicao_viagem: 34,
    tp_requisicao_compra: 24,
    tp_requisicao_outras_despesas: 88,
    tp_requisicao_suprimento_fundos: 38,
    tp_nota_fiscal: 54,
    tp_atualizacao_cadastral: 10,
    tp_recibo_eletronico: 9,
    tp_ocorrencia_ferias: 6,
    tp_interessado_conta: 4,
    tipos_interessados: {
        colaborador: 1,
        conta: 4,
        fornecedor: 3,
        item_compra: 5,
        prestacao_contas: 6,
        projeto: 2,
        processo: 7,
    },
    params_demais_usuario: { exclude_status: '200,300,520,540,210,590' },
    params_filtro_processar: { filter_status: '400,410,420,430,530' },
    vinculos_para_compra: [3, 4, 5],
    documentos_para_atualizacao_cadastral: [
        16, 20, 21, 22, 23, 25, 35, 36, 48, 51, 57, 67, 78, 81, 87,
    ],
    id_tp_produto: 61,
};

export const environment: IEnvironment = {
    theme: 'lccv',
    appVersion: require('../../package.json').version,
    production: true,
    host: `${window.location.origin}`,
    baseUrl: `${window.location.origin}/`,
    apiUrl: `${window.location.origin}/api/`,
    apiSettings,
    titlePrefix: 'Sumé |',
};
